import { withoutTrialLinks } from '@/lib/cta-links';

const LANDING_PAGE_HEADER_PROPS = {
  desktopMenuLinks: [
    {
      type: 'primary' as const,
      title: 'Request a demo',
      href: '',
      action: 'demo' as const,
    },
    {
      type: 'secondary' as const,
      title: 'Try for free',
      href: '',
      action: 'trial' as const,
    },
  ],
  mobileMenuLinks: [
    {
      type: 'primary' as const,
      title: 'Request a demo',
      href: '',
      action: 'demo' as const,
    },
    {
      type: 'secondary' as const,
      title: 'Try for free',
      href: '',
      action: 'trial' as const,
    },
  ],
};

/** Header CTAs for `/lp2/*` pages — demo only (no trial). */
export const LP2_LANDING_PAGE_HEADER_PROPS = {
  desktopMenuLinks: withoutTrialLinks(LANDING_PAGE_HEADER_PROPS.desktopMenuLinks),
  mobileMenuLinks: withoutTrialLinks(LANDING_PAGE_HEADER_PROPS.mobileMenuLinks),
};

export default LANDING_PAGE_HEADER_PROPS;
